"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Roles = require("../constants/roles");
function hasStaffRole(roles) {
    return (roles.includes(Roles.ORGANISATION_ADMIN_ROLE) ||
        roles.includes(Roles.COORDINATOR_ROLE) ||
        roles.includes(Roles.CARER_COORDINATOR_ROLE) ||
        roles.includes(Roles.CUSTOMER_CARER_ROLE) ||
        roles.includes(Roles.CARER_ROLE));
}
exports.hasStaffRole = hasStaffRole;
function hasOrganisationManagementRole(roles) {
    return roles.includes(Roles.ORGANISATION_ADMIN_ROLE) || roles.includes(Roles.COORDINATOR_ROLE);
}
exports.hasOrganisationManagementRole = hasOrganisationManagementRole;
function hasFamilyRole(roles) {
    return roles.includes(Roles.FAMILY_ROLE) || roles.includes(Roles.CUSTOMER_FAMILY_ROLE);
}
exports.hasFamilyRole = hasFamilyRole;
//# sourceMappingURL=role-helpers.js.map